import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export default function PanelHeader({ children, className }) {
  const headerClass = classNames('d-inline-flex align-items-center w-100 mb-3', className);

  return (
    <div className={headerClass}>
      {children}
    </div>
  );
}

PanelHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
